import * as React from "react";
import Box from "@mui/material/Box";
import "./tooltipCss.css";
const style = {
  position: "relative",
  top: "0%",
  left: "0%",
  p: 0.5,
  bgcolor: "background.paper",
  zIndex: 2,
  fontSize: "16px",
  fontFamily: "Nunito",
};

export default function InfoPopup({ e }) {
  return (
    <th class="tooltip-wrap">
      {e.id}
      <div class="tooltip-content">
        <Box sx={style}>{e.name}</Box>
      </div>
    </th>
  );
}
